<section id="about-hero" class="w-100 text-light" style="margin-top: 66px;">
    <div class="container py-5">
        <div class="text-center">
            <h4 class="text-dark">Registration detials</h4>
        </div>
        <div class="card">
            <p-table #dt [columns]="cols" [value]="studentsDetails" [exportHeader]="'customExportHeader'" showGridlines
                [scrollable]="true" scrollHeight="400px" [paginator]="true" [rows]="10"
                [rowsPerPageOptions]="[5, 10, 20]"
                [globalFilterFields]="['email', 'name', 'degreeandBranch','phoneNumber','collegeName','universityName']"
                class="p-datatable-striped" [tableStyle]="{'min-width': '50rem'}">
                <ng-template #caption>
                    <div class="d-flex align-items-center justify-content-between">
                        <p-iconfield iconPosition="left" class="d-inline-block">
                            <p-inputicon>
                                <i class="pi pi-search"></i>
                            </p-inputicon>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="Search" />
                        </p-iconfield>

                        <p-button icon="pi pi-external-link" label="Export" (click)="dt.exportCSV()" />
                    </div>
                </ng-template>

                <ng-template #header let-columns>
                    <tr>
                        <th *ngFor="let col of columns" pSortableColumn="{{ col.field }}">
                            {{ col.header }} <p-sortIcon field="{{ col.field }}"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template #body let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns;let i=index">
                            <div *ngIf="col.header=='Date'">{{ rowData[col.field] | date:'longDate' }}</div>
                            <div *ngIf="col.header!='Date'">{{ rowData[col.field]}}</div>

                        </td>
                    </tr>
                </ng-template>
            </p-table>



        </div>
    </div>
</section>